import { destr } from 'destr';

/**
 * Local storage utility functions for managing data in the browser.
 * All keys are prefixed with 'ASL/' to namespace the storage.
 *
 * @module localStorage
 */

const ASL_LOCAL_STORAGE_KEY = 'ASL';

export const LOCAL_STORAGE_KEYS = {
  DATASOURCE_CREATE_ENABLED: `${ASL_LOCAL_STORAGE_KEY}/DATASOURCE_CREATE_ENABLED`,
};

export const prefixStorageKey = (key: string, extraPrefix?: string) =>
  `${ASL_LOCAL_STORAGE_KEY}/${extraPrefix ? `${extraPrefix}/` : ''}${key}`;

export const getLocalStorageValue = <T>(key: string): T | undefined => {
  if (typeof window !== 'undefined') {
    return destr<T>(`${window.localStorage.getItem(key)}`);
  }
  return undefined;
};

export const setLocalStorageValue = <T>(key: string, value: T) => {
  if (typeof window !== 'undefined') {
    window.localStorage.setItem(
      key,
      typeof value === 'string' ? value : JSON.stringify(value),
    );
  }
};

export const deleteLocalStorageValue = (key: string) => {
  if (typeof window !== 'undefined') {
    window.localStorage.removeItem(key);
  }
};
